import './StageCreation.css'
import { useState, useEffect, useCallback, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { useCreateStageMutation } from '../../redux/singleTournamentService/singleTournamentApiSlice'
import { setActiveComponent } from '../../redux/singleTournamentService/singleTournamentSlice'
import { ButtonWhite } from '../ButtonWhite/ButtonWhite'

import { calculateNumberOfGroups, calculateNumberOfPlayers } from './externalFunctions'

function StageCreationComponent({ tournament }) {
	const { t } = useTranslation()
	// const navigate = useNavigate()
	const dispatch = useDispatch()
	const { tournamentUid } = useParams()
	const [createStage] = useCreateStageMutation()

	const [groupType, setGroupType] = useState(1)
	const [count, setCount] = useState(0)
	const [buttonLight, setButtonLight] = useState(1)

	useEffect(() => {
		const groupNumbers = calculateNumberOfGroups(tournament?.players ?
			tournament?.players.length
			:
			tournament?.doubles.length
		)

		setCount(groupNumbers)
	}, [tournament])

	const handleGroupType = useCallback((number) => {
		if (number === 1) {
			setGroupType(1)
			const groupNumbers = calculateNumberOfGroups(
				tournament?.players ?
					tournament?.players.length
					:
					tournament?.doubles.length
			)
			setCount(groupNumbers)

		} else if (number === 2) {
			setGroupType(2)

			const firstGroupPlayers = calculateNumberOfPlayers(
				tournament?.players ?
					tournament?.players.length
					:
					tournament?.doubles.length
			)
			setCount(firstGroupPlayers)
		}
	}, [groupType])

	const handleMinus = useCallback(() => {
		if (count < 1) {
			return
		} else {
			setCount(prev => --prev)
		}
	}, [count])

	const handlePlus = useCallback(() => {
		if (count === 32) {
			return
		} else {
			setCount(prev => ++prev)
		}
	}, [count])

	const handleInput = useCallback((e) => {
		if (e.target.value > 32) {
			setCount(32)
		}
		else if (e.target.value.startsWith('0') && e.target.value.length > 1) {
			const newCount = e.target.value.replace(/0/, '')

			setCount(newCount)
		}
		else {
			setCount(e.target.value)
		}
	}, [])

	const handleSubmit = useCallback(async (event) => {
		event.preventDefault()
		setButtonLight(1)
		let body = null

		if (groupType === 1) {
			body = {
				'generate_method': 'equal',
				'groups_count': count
			}
		} else if (groupType === 2) {
			body = {
				'generate_method': 'unequal',
				'group1_participants_count': count
			}
		}

		try {
			const response = await createStage({ tournament_uid: tournamentUid, body }).unwrap()

			if (response?.error) {
				console.log('authomatical creation of createStage catch error', response?.error)
			}

			sessionStorage.removeItem('activatedComponent')
			sessionStorage.setItem('stageOrder', response?.order_number)
			dispatch(setActiveComponent(''))
		}
		catch (e) {
			console.log('authomatical creation in stageCreation catch error', e)
		}
	}, [count, groupType])

	// const handleManualFormation = async () => {
	//   setButtonLight(2)
	//   const body = {}

	//   try {
	//     const response = await createStage({ tournament_uid: tournamentUid, body }).unwrap()

	//     if (response?.error?.status === 401) {
	//       navigate("/")
	//     } 
	//     else if (response?.error) {
	//       console.log("manual creation of createStage catch error", response?.error)

	//       return
	//     }

	//     sessionStorage.removeItem("createStage", false)
	//     sessionStorage.setItem("stageOrder", props?.tournament?.stages_count + 1)
	//   } 
	//   catch (e) {
	//     console.log("manual formation in stageCreation catch error", e)
	//   }
	// }

	return (
		<>
			<form onSubmit={handleSubmit} className="stage-creation">
				<p className="stage-creation__participants">
					{t('Number of participants')} {tournament?.players?.length || tournament?.doubles?.length || 0}
				</p>

				<div
					className={groupType === 1 ?
						'stage-creation__input--checked'
						:
						'stage-creation__input'
					}
					onClick={() => handleGroupType(1)}
				>
					<div className="radio-button__container">
						<input
							id="radio-1"
							type="radio"
							name="stageType"
							value="1"
							checked={groupType === 1 ? true : false}
							onChange={() => handleGroupType(1)}
						/>

						<label
							htmlFor="radio-1"
							style={{
								cursor: 'pointer'
							}}
						>
							{t('Group stage')}
						</label>
					</div>
				</div>

				<div
					className={groupType === 2 ?
						'stage-creation__input--checked'
						:
						'stage-creation__input'}
					onClick={() => handleGroupType(2)}
				>
					<div className="radio-button__container">
						<input
							id="radio-2"
							type="radio"
							name="stageType"
							value="2"
							checked={groupType === 2 ? true : false}
							onChange={() => handleGroupType(2)}
						/>

						<label
							htmlFor="radio-2"
							style={{
								cursor: 'pointer'
							}}
						>
							{t('Main stage')}
						</label>
					</div>
				</div>

				<div className="stage-creation__groups">
					<label className="stage-creation__label">
						{
							groupType === 1 ?
								t('Number of groups')
								:
								t('Number of participants in the first group')
						}
					</label>

					<div className="stage-creation__counter">
						<button
							type={'button'}
							onClick={() => handleMinus()}
							className="stage-creation__button-counter"
						>
							-
						</button>

						<input
							type="number"
							value={count}
							name="count"
							onChange={e => handleInput(e)}
							maxLength="2"
							className="stage-creation__counter-input"
						/>

						<button
							type={'button'}
							onClick={() => handlePlus()}
							className="stage-creation__button-counter"
						>
							+
						</button>
					</div>
				</div>

				<ButtonWhite
					light={buttonLight === 1 ? true : false}
					className="form-submit--automatical-formation"
					type={'submit'}
					title={t('Generate stage')}
				/>

				{/* <div className="form-submit--manual-formation">
          <Button
            light={buttonLight === 2 ? true : false}
            type={"button"}
            onClick={() => handleManualFormation()}
            title={t("Build the structure manually")}
          />
        </div> */}
			</form>
		</>
	)
}

export const StageCreation = memo(StageCreationComponent)